import { formatDateTime } from '../../common/formatDateText';

export const PaymentHistoryTimeline = ({ history = [] }) => {
    if (!history || history.length === 0) {
        return null;
    }

    return (
        <div className="space-y-6">
            {history.map((entry, index) => (
                <div key={entry._id || index} className="relative flex gap-4">
                    {/* Línea vertical del timeline - solo entre elementos */}
                    {index < history.length - 1 && (
                        <div className="absolute left-3.5 top-8 bottom-0 w-0.5 bg-gray-200 -mb-6" />
                    )}
                    
                    {/* Icono circular - centrado verticalmente con el contenedor */}
                    <div className="flex-shrink-0 relative z-10 pt-0">
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 border-white ${
                            entry.action === 'validado' ? 'bg-emerald-100' :
                            entry.action === 'rechazado' ? 'bg-rose-100' :
                            'bg-blue-100'
                        }`}>
                            {entry.action === 'validado' && (
                                <svg className="w-4 h-4 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                            )}
                            {entry.action === 'rechazado' && (
                                <svg className="w-4 h-4 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            )}
                            {entry.action === 'actualizado' && (
                                <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                            )}
                        </div>
                    </div>

                    {/* Contenido de la entrada */}
                    <div className={`flex-1 border rounded-lg p-4 ${
                        entry.action === 'validado' ? 'border-emerald-200 bg-emerald-50' :
                        entry.action === 'rechazado' ? 'border-rose-200 bg-rose-50' :
                        'border-blue-200 bg-blue-50'
                    }`}>
                        <div className="flex items-start justify-between mb-2">
                            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold uppercase ${
                                entry.action === 'validado' ? 'bg-emerald-200 text-emerald-800' :
                                entry.action === 'rechazado' ? 'bg-rose-200 text-rose-800' :
                                'bg-blue-200 text-blue-800'
                            }`}>
                                {entry.action}
                            </span>
                            <span className="text-xs text-gray-600 font-medium">
                                {formatDateTime(entry.date)}
                            </span>
                        </div>
                        
                        {entry.reason && (
                            <div className="mt-3">
                                <p className="text-xs font-semibold text-gray-700 mb-1">Motivo:</p>
                                <p className="text-sm text-gray-800 leading-relaxed">
                                    {entry.reason}
                                </p>
                            </div>
                        )}
                        
                        <div className="mt-3 pt-3 border-t border-gray-200">
                            <p className="text-xs text-gray-600">
                                <span className="font-semibold">Realizado por:</span>{' '}
                                <span className="text-gray-800 capitalize font-medium">
                                    {typeof entry.byWho === 'object' 
                                        ? `${entry.byWho?.firstName || ''} ${entry.byWho?.secondName || ''} ${entry.byWho?.lastName || ''} ${entry.byWho?.secondSurname || ''}`.trim()
                                        : entry.byWho || 'Sistema'}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
